import { render, staticRenderFns } from "./BCardActions.vue?vue&type=template&id=80e90084&scoped=true&"
import script from "./BCardActions.vue?vue&type=script&lang=js&"
export * from "./BCardActions.vue?vue&type=script&lang=js&"
import style0 from "./BCardActions.vue?vue&type=style&index=0&id=80e90084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e90084",
  null
  
)

export default component.exports